import { Box, Flex, Text } from '@chakra-ui/react';
import React, { useEffect, useMemo, useState } from 'react';
import DocViewer, {
  DocViewerRenderers,
  IDocument,
  IConfig
} from 'react-doc-viewer';

type Props = {
  file: string | File | null;
};

const DocumentViewer: React.FC<Props> = ({ file }) => {
  const [localFileUrl, setLocalFileUrl] = useState<string | null>(null);

  const config: IConfig = useMemo(
    () => ({
      header: {
        disableHeader: true,
        disableFileName: true,
        retainURLParams: false
      }
    }),
    []
  );

  useEffect(() => {
    if (!(file instanceof File)) {
      setLocalFileUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setLocalFileUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [file]);

  const viewerDocuments = useMemo<IDocument[]>(() => {
    if (!file) return [];

    if (file instanceof File) {
      if (!localFileUrl) return [];

      return [
        {
          uri: localFileUrl,
          fileName: file.name,
          fileType: file.type
        }
      ];
    }

    return [{ uri: file }];
  }, [file, localFileUrl]);

  return (
    <Box
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      width="full"
      maxWidth="100%"
      overflow="hidden"
      p={2}
    >
      <Box h={{ base: '60vh', md: '80vh' }} overflow="auto" bg="white">
        {viewerDocuments.length > 0 ? (
          <DocViewer
            documents={viewerDocuments}
            pluginRenderers={DocViewerRenderers}
            config={config}
            style={{ height: '100%' }}
          />
        ) : (
          <Flex h="100%" align="center" justify="center">
            <Text textStyle="textBody">No document available.</Text>
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default DocumentViewer;
